<mat-card class="dialog-card variable-chart">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar flex items-center justify-between" color="accent">
      <h1 class="dialog-card-title">{{ (
        data.type === 'cylinder' ? 'I18N_CHART.RSSI_CYLINDER' : 'I18N_CHART.RSS_DISTRIBUTION'
      ) | translate }}</h1>
      <button (click)="close()" cdkMonitorSubtreeFocus class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content">
    @if(data.id) {
      @if (data.type === 'cylinder') {
        <oyan-ui-chart-rssi-cylinder
          [id]="data.id"
        />
      } @else if (data.type === 'receiver') {
        <oyan-ui-chart-rssi-receiver
          [id]="data.id"
        />
      }
    }
  </mat-card-content>
</mat-card>
